import liff from '@line/liff/dist/lib';
import LoggingApi from '@/apis/LoggingApi';
import QuizApi from '@/apis/QuizApi';

export default class QuizUtils {
  static sendAnswerReport(quizCode: string): void {
    if (liff.isInClient()) {
      LoggingApi.log('sent liff result message');
      liff.sendMessages([{
        type: 'text',
        text: `complete.${quizCode}`,
      }]);

      LoggingApi.log(`sent message: complete.${quizCode}`);
    } else {
      LoggingApi.log('sent browser result message');
      QuizApi.browserSubmit(quizCode, '{}');
    }
  }
}
